import { css, space, palette } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3;
var FieldWrapper = {
  LabelWrapper: {
    styles: {
      base: function base(props) {
        return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        margin-bottom: ", "rem;\n      "])), space(2)(props));
      }
    }
  },
  TooltipPopover: {
    styles: {
      base: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        background-color: rgb(255, 251, 217);\n        line-height: 1.2;\n      "])))
    }
  },
  TooltipTrigger: {
    styles: {
      base: function base(props) {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        border: none;\n        background: unset;\n        min-height: unset;\n        height: unset;\n        padding: 0.1em 0.2em;\n        position: absolute;\n        top: -0.75em;\n        height: 22px;\n\n        &:hover {\n          background: unset;\n          color: ", ";\n        }\n\n        &&&:focus {\n          background: unset;\n          outline: none;\n          border: none;\n          color: ", ";\n        }\n      "])), palette('text')(props), palette('text')(props));
      }
    }
  }
};

export default FieldWrapper;
